// NOTE: Marketing-facing licensing page. The landing site is intended for
// pre-signup visitors; logged-in users on app.sessions.blue should ideally
// stay in-app. Plan: re-implement licensing inside blue-dot-frontend so
// returning users aren't bounced out of the app. Until then, this page is
// the single source of truth and the frontend full-page-redirects here.
import React from "react";
import Layout from "../components/Layout";
import LicensingPage from "../components/LicensingPage";
import { Helmet } from "../components/Layout/helmet";

const License = () => {
  return (
    <Layout>
      <LicensingPage />
    </Layout>
  );
};
export const Head = () => <Helmet />;

export default License;
